import { Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Column } from '../../decorators';
import { BaseEntity } from './base.entity';
import { CompanyEntity } from './company.entity';
import { ShippingMethodEntity } from './shipping-method.entity';

@Index(
	'shipping_method_company_unique',
	['fkShippingMethodId', 'fkCompanyId'],
	{
		unique: true,
	},
)
@Entity('shipping_method_company')
export class ShippingMethodCompanyEntity extends BaseEntity {
	@Column('int', {
		name: 'fk_shipping_method__id',
		unsigned: true,
	})
	public fkShippingMethodId!: number;

	@Column('int', {
		name: 'fk_company__id',
		unsigned: true,
	})
	public fkCompanyId!: number;

	@ManyToOne(
		() => ShippingMethodEntity,
		(shippingMethod) => shippingMethod.companies,
		{
			onDelete: 'CASCADE',
			onUpdate: 'CASCADE',
		},
	)
	@JoinColumn([{ name: 'fk_shipping_method__id', referencedColumnName: 'id' }])
	public shippingMethod!: ShippingMethodEntity;

	@ManyToOne(
		() => CompanyEntity,
		(company) => company.shippingMethodCompanies,
		{
			onDelete: 'CASCADE',
			onUpdate: 'CASCADE',
		},
	)
	@JoinColumn([{ name: 'fk_company__id', referencedColumnName: 'id' }])
	public company!: CompanyEntity;
}
